import React from "react";
import Typography from "@material-ui/core/Typography/Typography";
import { WithStyles, withStyles } from "@material-ui/core";
import { styles } from "../RegisterView.styles";
import { CenteredContainer } from "../../components/CenteredContainer/CenteredContainer";
import { BlueButton } from "../../components/Buttons/BlueButton";
import { useHistory } from "react-router-dom";

export interface IRegisterSuccessViewProps extends WithStyles<typeof styles> {}

const RegisterSuccessViewPure: React.FunctionComponent<IRegisterSuccessViewProps> = ({ classes }) => {
    const history = useHistory();
    return (
        <CenteredContainer>
            <Typography variant="h3" gutterBottom>
                Thank you for your registration!
            </Typography>
            <Typography variant="h5">
                We have sent you an email with further details. Please check your mailbox.
            </Typography>
            <BlueButton onClick={() => history.push("/products")}>Go to the products overview</BlueButton>
        </CenteredContainer>
    );
};

export const RegisterSuccessView = withStyles(styles)(RegisterSuccessViewPure);
